interface Obj {
  [key: string]: any
}

const objToFormdata = (obj: Obj) => {
  const ret = new FormData()
  for (const key in obj) {
    ret.append(key, obj[key])
  }
  return ret
}

export default objToFormdata
